import { Box, Button, Divider, Typography } from '@mui/material';
import React from 'react'
const Heading = ({ title, sx, fontWeight,showSeeAll = false, onSeeAllClick }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        ...sx,
      }}
    >
      <Typography variant="h6" fontWeight={fontWeight || "bold"}>
        {title}
      </Typography>
      {showSeeAll && (
        <Button
          variant="text"
          onClick={onSeeAllClick}
        >
          See all
        </Button>
      )}
    </Box>
  );
}

export default Heading
